import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { FormGroup,FormControl, FormArray,Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { stringify } from 'querystring';

var PasswordCredential: any

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css']
})


export class SignInComponent implements OnInit {

  formAdmin: any;
  userData:any;
  userFinal:any;
  invalidCredentialMsg: string;
  

  constructor(
    public authService: AuthService,
    public router: Router
  ) { 

   
    this.formAdmin = new FormGroup({
      email: new FormControl(""),
      password: new FormControl("")
    })

     


 
}  
  

   
  
  

  

  ngOnInit() { 
    
    
  }

  

  onSubmit(dataAdmin:any){

    
    
    this.authService.postLogin(dataAdmin)
        .subscribe (res=>{

			//let datos = stringify(res['body'])

         // console.log ('qr : '+ datos);


          if (res) {
            
            this.userData = res;
            this.userFinal = this.userData.usuario;
		
            localStorage.removeItem('sfeJfsld8dsKld5lRld');
			localStorage.removeItem('kk-3345--w45');
            
            localStorage.setItem('sfeJfsld8dsKld5lRld', this.userData.token);
			localStorage.setItem('kk-3345--w45',this.userData.usuario._id);
            let url = this.authService.getRedirectUrl();
            //console.log('Redirect Url:' + url);
            this.router.navigate([url]);
					
			// El siguiente codigo se usa para la autenticacion con dos factores
			/*this.userData = res;
		    let userFinal =this.userData.cuerpo;
			//console.log(typeof userFinal);*/
			

			
           //this.router.navigate(['verify-sms'],{queryParams:{data: userFinal}});
            

          } else {
            localStorage.setItem('sfeJfsld8dsKld5lRld', "null");
            this.invalidCredentialMsg = 'Invalid Credentials. Try again.';

          
          } 
        });   
  }

}
